import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostUnitDialogModule } from './cost-unit-dialog/cost-unit-dialog.module';
import { CostUnitPage } from './cost-unit.page';
import { MatSortModule } from '@angular/material/sort';


export * from './cost-unit.page';
export * from './cost-unit-dialog/cost-unit-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostUnitPage,
    },
];

@NgModule({
    declarations: [ CostUnitPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        CostUnitDialogModule,
        MatProgressBarModule,
        TranslateModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class CostUnitPageModule {
}
